module.exports = __webpack_public_path__ + "static/media/blog-bg_new.e024fdaa.jpg";